<template>
    <div class="main_box">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item >基本信息管理</el-breadcrumb-item>
            <el-breadcrumb-item>角色管理</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="content">
            <el-form class="form" :model="form" :inline="true" size="small" ref="form">
                <el-form-item label="角色名称" prop="param.name">
                    <el-input v-model="form.param.name"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="query">搜索</el-button>
                    <el-button @click="$refs.form.resetFields()">清空</el-button>
                </el-form-item>
            </el-form>

            <el-button class="mt20" size="small" type="primary" @click="handleAdd">新增角色</el-button>

            <el-table class="table"  :data="data" border>
                <el-table-column label="序号" type="index" width="50px"></el-table-column>
                <el-table-column label="名称" prop="name" width="200px"></el-table-column>
                <el-table-column label="状态" prop="enable" width="100px"  :formatter="formatEnable" ></el-table-column>
                <el-table-column label="备注" prop="memo" width="300px" ></el-table-column>
                <el-table-column label="操作" >
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
                        <el-button type="text" size="small" @click="handlePermiss(scope.row)" >授权</el-button>
                        <el-button type="text" size="small" @click="handleDel(scope.row)" >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <gl-page @size-change="sizeChange" @current-change="query" :current-page="form.pageNum" :page-size="form.pageSize" :total="total"></gl-page>
        </div>
        <!--新增界面-->
		<el-dialog title="新增角色" :visible.sync="addFormVisible" :close-on-click-modal="false"  size="tiny" >
			<el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm" >
				<el-form-item label="名称" prop="name" style="width:300px;">
					<el-input v-model="addForm.name" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="备注" prop="memo" style="width:300px;">
					<el-input v-model="addForm.memo" auto-complete="off"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="addFormVisible = false">取 消</el-button>
				<el-button type="primary" @click.native="addSubmit" :loading="addLoading">{{btnAddText}}</el-button>
			</div>
		</el-dialog>

		<!--编辑界面-->
		<el-dialog title="编辑角色" :visible.sync="editFormVisible" :close-on-click-modal="false"  size="tiny">
			<el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm" >
				<el-form-item label="名称" prop="name" style="width:300px;">
					<el-input v-model="editForm.name" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="备注" prop="memo" style="width:300px;">
					<el-input v-model="editForm.memo" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="状态">
					<el-radio-group v-model="editForm.enable">
						<el-radio class="radio" :label="true">正常</el-radio>
						<el-radio class="radio" :label="false">禁用</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取 消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">{{btnEditText}}</el-button>
			</div>
		</el-dialog>
		
		<!--权限界面-->
		<el-dialog title="编辑权限" :visible.sync="permissFormVisible" :close-on-click-modal="false" size="tiny">
			<el-form :model="permissForm" label-width="80px"  ref="permissForm" >
				<el-tree
				  :data="permissTree"
				  :props="permissProps"
				  ref="permissTree"
				  node-key="permiss"
				  show-checkbox
                  >
				</el-tree>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="permissFormVisible = false">取 消</el-button>
				<el-button type="primary" @click.native="permissSubmit" :loading="permissLoading">{{btnPermissText}}</el-button>
			</div>
		</el-dialog>
    </div>
</template>
<script>
import glPage from '../../components/glPage';
import menu from '../../menu'
export default {
    components: {
        glPage
    },
    data() {
        return {
            form: {
                pageNum: 1,
                pageSize: 10,
                param:{
                    name: '',
                },
            },
            data: [],
            total:0,

            addFormVisible:false,//编辑界面显是否显示
            //编辑界面数据
            addForm: {
                name:'',
                memo:'',
                app:'admin',
            },
            addFormRules:{
                name:[
                    { required: true, message: '请输入名称', trigger: 'blur' }
                ]
            },
            addLoading:false,
            btnAddText:'提 交',
            
            editFormVisible:false,//编辑界面显是否显示
            //编辑界面数据
            editForm: {
                id:0,
                name:'',
                memo:'',
                enable:true,
            },
            editFormRules:{
                name:[
                    { required: true, message: '请输入姓名', trigger: 'blur' }
                ]
            },
            editLoading:false,
            btnEditText:'提 交',
            
            
            permissFormVisible:false,//编辑界面显是否显示
            permissForm:{
                id:0,
                permissions:'',
            },
            permissLoading:false,
            btnPermissText:'提 交',
            permissTree:[],
            permissProps:{
                label: 'title',
                children: 'children'
            },
        }
    },
    mounted() {
        this.permissTree = menu.menuTree;
        this.query();
    },
    methods: {
        query(a) {
            if(isNaN(a)) {
                a = 1
            }
            this.form.pageNum = a
             this.ajax.post('/role/admin/getList', this.form).then(data => {
                 this.data= data.list
                 this.total= data.total
            })
        },
        sizeChange(a) {
            console.log(a)
            this.form.pageSize = a
            this.query()
        },
        formatEnable:function(row,column){
				return row.enable?'正常':'禁用';
        },
        formatIsSystem:function(row,column){
            return row.isSystem?'是':'否';
        },

        //显示新增界面
        handleAdd:function(){
            this.btnAddText='提交';
            this.addLoading=false;
            this.addFormVisible=true;
            this.addForm.name='';
            this.addForm.memo='';
        },
			
        //新增
        addSubmit:function(){
            this.$refs.addForm.validate((valid)=>{
                if(valid){
                    this.$confirm('确认提交吗？','提示',{}).then(()=>{
                        this.addLoading=true;
                        this.btnAddText='提交中';
                        this.ajax.post('/role/admin/insert', this.addForm).then(data => {
                            this.$message({
                                type: 'success',
                                message: '操作成功！'
                            })
                            this.addLoading=false;
                            this.btnAddText='提 交';
                            this.query();
                            this.addFormVisible = false;
                            this.$refs.addForm.resetFields()
                        })
                    }).catch(() => {
                    });
                }
            });
        },
			
        //显示编辑界面
        handleEdit:function(row){
            this.btnEditText='提交';
            this.editLoading=false;
            this.editFormVisible=true;
            this.editForm.id=row.id;
            this.editForm.name=row.name;
            this.editForm.memo=row.memo;
            this.editForm.enable=row.enable;
        },
        //编辑
        editSubmit:function(){
            this.$refs.editForm.validate((valid)=>{
                if(valid){
                    this.$confirm('确认提交吗？','提示',{}).then(()=>{
                        this.editLoading=true;
                        this.btnEditText='提交中';
                        this.ajax.post('/role/admin/update', this.editForm).then(data => {
                            this.$message({
                                type: 'success',
                                message: '操作成功！'
                            })
                            this.edtiLoading=false;
                            this.btnEditText='提 交';
                            this.query();
                            this.editFormVisible = false;
                            this.$refs.editForm.resetFields()
                        })
                    }).catch(() => {
                    });
                }
            });
        },
        //删除记录
        handleDel:function(row){
            let idParam = {
                id : row.id,
            }
            this.$confirm('确认删除该记录吗?', '提示', {
            }).then(() => {
                this.ajax.post('/role/admin/delete', idParam).then(data => {
                    this.$message({
                        type: 'success',
                        message: '操作成功！'
                    })
                    this.edtiLoading=false;
                    this.btnEditText='提 交';
                    this.query();
                    this.editFormVisible = false;
                })
            }).catch(() => {
            });
        },
			
        //显示编辑界面
        handlePermiss:function(row){
            this.btnPermissText='提交';
            this.permissLoading=false;
            this.permissFormVisible=true;
            this.permissForm.id=row.id;
            this.ajax.get('/role/common/getPermisses/byRoleId', {roleId:row.id}).then(data => {
                this.$refs.permissTree.setCheckedKeys(data);
            })
        },
        permissSubmit:function(){
            this.$confirm('确认提交吗？','提示',{}).then(()=>{
                this.permissLoading=true;
                this.btnPermissText='提交中';
                var checkedNodes = this.$refs.permissTree.getCheckedNodes();
                var i =0;
                for(i in checkedNodes){
                    if(checkedNodes[i].children){
                        continue;
                    }
                    let check = checkedNodes[i].permiss;
                    if( check != undefined){
                        this.permissForm.permissions = this.permissForm.permissions+ check +",";
                    }
                }
                this.ajax.post('/role/admin/permiss', this.permissForm).then(data => {
                    this.$message({
                        type: 'success',
                        message: '操作成功！'
                    })
                    this.permissLoading=false;
                    this.btnPermissText='提 交';
                    this.query();
                    this.permissFormVisible = false;
                    this.$refs.permissForm.resetFields()
                })
            }).catch(() => {
            });
        },

    }
    
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/basic/roleManager.vue